import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { Headers } from '@angular/http';
import { Http } from '@angular/http';
import { ApiService } from './api.service';
import { PanelMember } from '../model/panel-member.model';
import { Candidate } from '../model/candidate.model';
import * as _ from 'lodash';
import { Observable } from 'rxjs/internal/Observable';


@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(
    private http: Http,
    private apiService: ApiService
  ) { }

  private apiDomain = ApiService.getDomainName();
  private eventId = this.apiService.getEventId();

  // form: FormGroup = new FormGroup({
  //   file: new FormControl(null, [Validators.required, requiredFileType('xlsx, csv')])
  // });


  private handleError(error: any) {
    console.error('An error occurred', error);
    try {
       const errorJSON = error && error.json();
      if ( errorJSON.httpCode == 401 ) {
        ApiService.sessionExpireRedirection();
      }
      return Promise.reject(errorJSON);
    } catch(err) {
      return Promise.reject(error && error.message);
    }
  }

  uploadCandidate(file) {
    let candidateHeaders = new Headers({ 'Content-Type': 'text/plain', "file": file, 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.post(this.apiDomain + "ims/api/" + this.eventId + "/candidate/upload/", { headers: candidateHeaders })
      .toPromise()
      .then(response => response.json() as Candidate[])
      .catch(this.handleError);
  }

  uploadPanelMember(filePath) {
    let panelHeaders = new Headers({ 'Content-Type': 'text/plain', "file": filePath, 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.post(this.apiDomain + "ims/api/" + this.eventId + "/panelMember/upload/", { headers: panelHeaders })
      .toPromise()
      .then(response => response.json() as PanelMember[])
      .catch(this.handleError);
  }
}


export function fileExtensionValidator(validExt: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let forbidden = true;
    if (control.value) {
      const fileExt = control.value.split('.').pop();
      validExt.split(',').forEach(ext => {
        if (ext.trim() == fileExt) {
          forbidden = false;
        }
      });
    }
    return forbidden ? { 'inValidExt': true } : null;
  };
} 


export function requiredFileType(type: string) {
  return function (control: FormControl) {
    const file = control.value;
    if (file) {
      const extension = file.name.split('.')[1].toLowerCase();
      if (type.toLowerCase() !== extension.toLowerCase()) {
        return {
          requiredFileType: true
        };
      }
      return null;
    }
    return null;
  };
}
